export default (str: string, maxLength = 30, separator = '...'): string => {
  if (str.length > maxLength) {
    const firstHalf = str.substring(0, maxLength / 2)
    const secondHalf = str.substring(str.length - maxLength / 2)
    return `${firstHalf}${separator}${secondHalf}`
  }

  return str
}
